import { registerMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const SUBMIT_REPLY = registerMutation({
  fieldName: 'submitReply',
  args: ['reply', 'reviewId'],
  fetcher: ({
    reply,
    reviewId
  }) => http.post(`ecosystem/v1/reviews/${reviewId}/reply`, {
    data: {
      reply
    }
  })
});